import { gql } from '@apollo/client';

export const WORKSPACE_LIST = gql`
  query workspaceList($limit: Int!, $offset: Int!, $search: String) {
    workspaceList(limit: $limit, offset: $offset, search: $search) {
      companies {
        id
        name
      }
      totalCount
    }
  }
`;
